/* global __DEV__ */
/* eslint-disable import/no-import-module-exports */
import React from 'react';
// we can safely allow the dev dependency for deepForceUpdate
// on production, webpack will nullify it
// eslint-disable-next-line import/no-extraneous-dependencies
import deepForceUpdate from 'react-deep-force-update';
import { render } from 'react-dom';
import { TrackJS } from 'trackjs';
import App from './App';

import './i18n';

// get the container
const container = document.getElementById('app');

// get app data sent by the back
const appData = JSON.parse(container.dataset.app);

let appInstance = null;

// Re-render the app when window.location changes
const renderApp = () => {
    try {
        if (!__DEV__ && !window.TrackJS && appData.TRACKJS_TOKEN) {
            TrackJS.install({
                token: appData.TRACKJS_TOKEN,
                application: appData.REACT_APP_TRACKJS_APP
            })
            TrackJS.addMetadata("project", "marco");
        }
        const appElement = <App appData={appData} />;

        // render it
        appInstance = render(appElement, container);
    } catch (error) {
        if (__DEV__) {
            throw error;
        }

        console.error(error);
    }
};

renderApp();

// Enable Hot Module Replacement (HMR)
if (module.hot) {
    module.hot.accept('./App', () => {
        if (appInstance && appInstance.updater.isMounted(appInstance)) {
            // Force-update the whole tree, including components that refuse to update
            deepForceUpdate(appInstance);
        }

        renderApp();
    });
}
